import { render, staticRenderFns } from "./reviewReport.vue?vue&type=template&id=2968a939"
import script from "./reviewReport.vue?vue&type=script&lang=js"
export * from "./reviewReport.vue?vue&type=script&lang=js"
import style0 from "./reviewReport.vue?vue&type=style&index=0&id=2968a939&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2968a939')) {
      api.createRecord('2968a939', component.options)
    } else {
      api.reload('2968a939', component.options)
    }
    module.hot.accept("./reviewReport.vue?vue&type=template&id=2968a939", function () {
      api.rerender('2968a939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/reviewReport.vue"
export default component.exports